import { booleanAttribute, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArtikelMenge } from '../../types/artikel-menge';
import { IsDefinedNotEmptyPipe } from '@softline/ui-core';
import { isDefinedNotEmpty } from '@softline/core';

@Component({
  selector: 'soft-artikel-menge',
  imports: [CommonModule, IsDefinedNotEmptyPipe],
  templateUrl: './artikel-menge.component.html',
  styleUrl: './artikel-menge.component.scss',
})
export class ArtikelMengeComponent {
  artikelMenge = input.required<ArtikelMenge>();
  showInvMenge = input<boolean>(false);

  readonly hideQuantity = input(false, { transform: booleanAttribute });

  protected readonly isDefinedNotEmpty = isDefinedNotEmpty;
}
